import { render } from "./ApplyDocs.vue?vue&type=template&id=bfbe3f78&scoped=true"
import script from "./ApplyDocs.vue?vue&type=script&lang=js"
export * from "./ApplyDocs.vue?vue&type=script&lang=js"

import "./ApplyDocs.vue?vue&type=style&index=0&id=bfbe3f78&scoped=true&lang=css"
import "./ApplyDocs.vue?vue&type=style&index=1&id=bfbe3f78&lang=less"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbe3f78"]])

export default __exports__